import i18n from 'i18next';
import { dateSeperator } from '../../config';
import { dateFormat } from '../../services/common/format';
import { Yup } from '../../services/common/validation';
import { regExEmail } from '../../services/common/validationUtils';

const regexName =
  /^[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß'\\.-][a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß '\\.-]+$/;
const regexPostalCode = /^-?\d+$/;

export const ProspectSearchPopupModalSchema = Yup.object().shape({
  lastName: Yup.string()
    .matches(regexName, () => i18n.t('validation:invalidCharacter'))
    .min(2, () => i18n.t('validation:minLength'))
    .max(120, () => i18n.t('validation:maxLength', { value: 120 }))
    .when(['firstName', 'email', 'dateOfBirth', 'postalCode', 'city'], {
      is: (firstName, email, dateOfBirth, postalCode, city) =>
        !firstName && !email && !dateOfBirth && !postalCode && !city,
      then: (schema) => schema.required(''),
    }),

  firstName: Yup.string().matches(regexName, () => i18n.t('validation:invalidCharacter')),
  dateOfBirth: Yup.string().dateFormat(dateFormat, dateSeperator, () => i18n.t('validation:invalidDateformat')),
  postalCode: Yup.string()
    .matches(regexPostalCode, i18n.t('validation:invalidCharacter'))
    .min(5, () => i18n.t('validation:minLength', { value: 5 }))
    .max(5, () => i18n.t('validation:maxLength', { value: 5 })),
  city: Yup.string()
    .matches(regexName, () => i18n.t('validation:invalidCharacter'))
    .min(2, () => i18n.t('validation:minLength', { value: 2 }))
    .max(120, () => i18n.t('validation:maxLength', { value: 120 })),
  email: Yup.string().matches(regExEmail, () => i18n.t('validation:invalidEmail')),
});
